export default "__VITE_ASSET__AoOSJ3Iu__"